import React, { useState } from 'react';
import NoDataPageContainer from '../components/NoDataPageContainer';
import ajaxUser from '../util/remote/ajaxUser';


const NoAccessPage = () => {

    const [loading, setLoading] = useState(false);


    const handleSwitchProfile = async() => {
        if(loading){
          return;
        }
        setLoading(true);
        const server_response = await ajaxUser.exitProfile();
        setLoading(false);
        if(server_response.status === "OK"){
            window.location.href = '/switch'
            window.location.reload();
        }
    }


    return (
        <NoDataPageContainer
            iconClass="fa fa-lock"
            title="Access Denied"
            subtitle="You currently have no permissions assigned to access this YEXP accounting workspace. Please contact your administrator to request access."
            actions={
                <>
                <button className="btn btn-outline-danger" onClick={() => window.location.href = '/'}>
                Return Home
                </button>
                <button className="btn btn-outline-primary ml-3" onClick={handleSwitchProfile}>
                Switch Profile
                </button>
                </>
            }
            />
    );
};

export default NoAccessPage;
